import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { AuthService, StorageService } from '../../../service';
import { UserEndPoint, AirAppRoutes, OceanAppRoutes, UMPAppRoutes } from '../../../../../modules/common/lib/air-api-constant';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';

@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {

  constructor(public storageService: StorageService,
    public authService: AuthService,
    public router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/login') {
          //cancle all api calls when logout
          this.authService.cancelPendingRequests();
        }
      }
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenDetails = this.storageService.getItem('token');
    const currentUrl = this.router.url;
    // console.log('Current Browser URL:', currentUrl);

    // Check browser URL for tracking key
    const browserTrackingKeyMatch = currentUrl.match(/external-tracking-list\/details\/([\w-]+)/);

    const airUserProfileUrls = [
      ...Object.values(UserEndPoint.UserPortal),
      ...Object.values(UserEndPoint.AirCommonService),
    ];
    const airPortalUrls = [
      ...Object.values(AirAppRoutes.DirectLink),
      ...Object.values(AirAppRoutes.DirectLink.DIRECT_LINK_ACCESS),
      ...Object.values(UserEndPoint.AirShipment),
      ...Object.values(UserEndPoint.Flight),
      ...Object.values(UserEndPoint.PortalProfile),
      ...Object.values(UserEndPoint.AirEventManagement),
      ...Object.values(UserEndPoint.AirFilters),
    ];
    const oceanPortalUrls = [
      ...Object.values(OceanAppRoutes.OceanCall)
    ];

    // const umpUrls = [
    //  ...Object.values(UMPAppRoutes.UserApi)
    // ];
    if (!/^(http|https):/i.test(request.url)) {
      AuthService.lastApiCall = moment();
      let url = '';
      if (airUserProfileUrls.indexOf(request.url) >= 0) {
        url = environment.air_portalendpoint_url + request.url;
      }
      else if (airPortalUrls.indexOf(request.url) >= 0) {
        url = environment.air_endpoint_url + request.url;
      }
      else if (oceanPortalUrls.indexOf(request.url) >= 0) {
        url = environment.portalendpoint_url + request.url;
      }
      // else if (umpUrls.includes(request.url)) {
      //   url = `${environment.ump_endpoint_url}/${request.url}`;
      // } 
      else {
        url = environment.air_endpoint_url + request.url;
      }
      const headers: any = {
        'Authorization': tokenDetails != null && tokenDetails !== '' ? 'Bearer ' + tokenDetails : '',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        ///  'x-Api-key': environment.x_api_key,
      }


      // Extracting the URL



      if (browserTrackingKeyMatch && browserTrackingKeyMatch[1]) {
        const trackingKey = browserTrackingKeyMatch[1];
        headers['x-Api-key'] = trackingKey;
      } else {
        // Fallback to checking API URL
        const apiTrackingKeyMatch = request.url.match(/external-tracking-list\/details\/([\w-]+)/);
        if (apiTrackingKeyMatch && apiTrackingKeyMatch[1]) {
          const trackingKey = apiTrackingKeyMatch[1];
          headers['x-Api-key'] = trackingKey;
        }
      }
      request = request.clone({
        url,
        headers: new HttpHeaders(headers)
      });
    }
    return next.handle(request).pipe(takeUntil(this.authService.onCancelPendingRequests()));
  }
}
